/** Moved to the React-free `@tunasong/ws-protocol` so Lambdas need not load the store (GH #1916). */
export { createObjectPath } from '@tunasong/ws-protocol'

/** Debounce function for accumulating calls. All promises will resolve/reject to the last call's result */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const debounceResolveAll = <T extends (...args: any[]) => any>(fn: T, delay: number) => {
  let timeoutId: ReturnType<typeof setTimeout> | null = null
  let pendingResolvers: { resolve: (value: ReturnType<T>) => void; reject: (error: unknown) => void }[] = []

  return (...args: Parameters<T>) => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }
    return new Promise<ReturnType<T>>((resolve, reject) => {
      pendingResolvers.push({ resolve, reject })

      timeoutId = setTimeout(() => {
        try {
          const result = fn(...args)
          pendingResolvers.forEach(({ resolve }) => resolve(result))
        } catch (error) {
          pendingResolvers.forEach(({ reject }) => reject(error))
        }
        pendingResolvers = []
      }, delay)
    })
  }
}
